import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTopSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 8.93945L17.0608 14.0001L16.0001 15.0608L12.0001 11.0608L8.00011 15.0608L6.93945 14.0001L12.0001 8.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopSmall;
